import { registerComponent } from '@gig/magic-common';
import NotificationComponent from './notification.vue.js';

var Notification = registerComponent(NotificationComponent);

export { Notification };
